const DIALOG_OFFSET = 10;

class HeaderAccount extends HTMLElement {
  connectedCallback() {
    this.account = this.querySelector('shopify-account');
    this.header = this.closest('header');
    this.text = this.querySelector('[data-account-text]');
    if (!this.account || !this.header) return;

    this.ticking = false;
    this.onScroll = this.onScroll.bind(this);
    this.updateTop = this.updateTop.bind(this);

    this.updateTop();
    window.addEventListener('resize', this.updateTop);
    if ('ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(this.updateTop);
      this.resizeObserver.observe(this.header);
      this.resizeObserver.observe(this.account);
    }

    this.account.addEventListener('open', () => {
      this.updateTop();
      this.classList.add('is-open');
      window.addEventListener('scroll', this.onScroll, { passive: true });
    });
    this.account.addEventListener('close', () => {
      this.classList.remove('is-open');
      window.removeEventListener('scroll', this.onScroll);
    });

    if (this.text) {
      this.text.addEventListener('click', () => {
        const button = this.getInnerButton();
        if (button) button.click();
      });
      customElements.whenDefined('shopify-account').then(() => this.markTextClickable());
    }
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.updateTop);
    window.removeEventListener('scroll', this.onScroll);
    if (this.resizeObserver) this.resizeObserver.disconnect();
  }

  onScroll() {
    if (this.ticking) return;
    this.ticking = true;
    requestAnimationFrame(() => {
      this.ticking = false;
      this.updateTop();
    });
  }

  // Mesmo padrão do tema Horizon: a sheet ancora na base do próprio componente (+ respiro).
  // getBoundingClientRect().bottom é coordenada de viewport, igual ao position: fixed do dialog
  updateTop() {
    const bottom = Math.max(0, Math.round(this.account.getBoundingClientRect().bottom));
    this.account.style.setProperty('--shopify-account-dialog-position-top', `${bottom + DIALOG_OFFSET}px`);
  }

  // Somente leitura do shadow DOM: localiza o botão do avatar para encaminhar o clique
  getInnerButton() {
    const root = this.account.shadowRoot;
    return root ? root.querySelector('button') : null;
  }

  markTextClickable() {
    // O avatar logado pode renderizar depois do upgrade do componente
    let attempts = 0;
    const check = () => {
      if (this.getInnerButton()) {
        this.text.classList.add('is-clickable');
      } else if (attempts++ < 20) {
        setTimeout(check, 250);
      }
    };
    check();
  }
}
customElements.define('header-account', HeaderAccount);
